import { render, staticRenderFns } from "./ItemSlickSub.vue?vue&type=template&id=e2ca090e&scoped=true&"
import script from "./ItemSlickSub.vue?vue&type=script&lang=js&"
export * from "./ItemSlickSub.vue?vue&type=script&lang=js&"
import style0 from "./ItemSlickSub.vue?vue&type=style&index=0&id=e2ca090e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ca090e",
  null
  
)

export default component.exports